class DisciplinesApi {
    constructor(DoclrHttp, praktijkContext) {
        'ngInject';

        this.praktijkContext = praktijkContext;
        this.DoclrHttp = DoclrHttp;
    }

    getDistinctDisciplines(){
        return this.DoclrHttp.get("/api/public/praktijk/"+ this.praktijkContext.id +"/disciplines");
    }
}

(function () {
    'use strict';
    angular.module('doclr.disciplines')
        .service('DisciplinesApi', DisciplinesApi)
})();
